import { Injectable } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { LoadingSpinnerService } from './../shared/services/loading-spinner.service';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import 'rxjs/add/operator/do';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } 
from '@angular/common/http';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
    
  constructor(private auth: AuthService, private loader:LoadingSpinnerService, private toastr:ToastsManager) {

  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    return next.handle(request).do((event) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
        this.loader.hideSpinner();
      }
    }, (ev: any) => {
      if (ev instanceof HttpErrorResponse) {
        this.loader.hideSpinner(); 
        if (ev.status === 401) {            
            this.toastr.error('You are not authorized for this operation');
        }else{
            let message:string='';
            try{ 
                if(typeof ev.error=='string'){
                    message=JSON.parse(ev.error).message;
                }               
                else if(ev.error.message){
                    message=ev.error.message
                }else{
                    Object.keys(ev.error).forEach((i)=>{
                        message+=ev.error[i]+' ';
                    })                
                }

            }catch(e){
                message=`Request data status ${ev.status}`;
            }
            this.toastr.error(message,"Error");
        }
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/auth/response.interceptor.ts